/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Notrecommended2Inputs */

const id_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Direkomendasikan`)
};

const ms_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Disyorkan`)
};

const da_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke Anbefalet`)
};

const de_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht empfohlen`)
};

const en_us2_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Recommended`)
};

const es_es2_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recomendado`)
};

const es_mx2_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recomendado`)
};

const fil_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Inirerekomenda`)
};

const fr_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non recommandé`)
};

const it_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non consigliato`)
};

const hu_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem ajánlott`)
};

const nl_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet aanbevolen`)
};

const no_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke anbefalt`)
};

const pl_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niepolecane`)
};

const pt_br2_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não recomendado`)
};

const pt_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não recomendado`)
};

const ro_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nerecomandat`)
};

const fi_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei suositeltu`)
};

const sv_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekommenderas inte`)
};

const vi_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không được đề xuất`)
};

const tr_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önerilmeyen`)
};

const cs_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedoporučeno`)
};

const bg_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е препоръчан`)
};

const ru_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не рекомендуется`)
};

const uk_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не рекомендую`)
};

const ar_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير موصى به`)
};

const hi_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुशंसित नहीं`)
};

const th_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่แนะนำ`)
};

const ja_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おすすめしない`)
};

const zh_cn2_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不推荐`)
};

const zh_hant1_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不推薦`)
};

const ko_offerdetail_reviews_notrecommended2 = /** @type {(inputs: Offerdetail_Reviews_Notrecommended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천하지 않음`)
};

/**
* | output |
* | --- |
* | "Not Recommended" |
*
* @param {Offerdetail_Reviews_Notrecommended2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_notrecommended2 = /** @type {((inputs?: Offerdetail_Reviews_Notrecommended2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Notrecommended2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "da") return da_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "de") return de_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "it") return it_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "no") return no_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "th") return th_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_notrecommended2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_notrecommended2(inputs)
	return ko_offerdetail_reviews_notrecommended2(inputs)
});
export { offerdetail_reviews_notrecommended2 as "offerDetail.reviews.notRecommended" }